module.exports = __webpack_public_path__ + "static/media/fun6.65ce3ccc.png";